<template>
  <div>
    <div class="container" v-if="fill_info == ''">
      <div class="row">
        <div class="col-xs-12 col-md-3">
          <div class="info-box warning"><a href="javascript:void(0)" title="Kitöltési útmutató">Kitöltési útmutató letöltése</a></div>
        </div>

        <!-- Űrlap -->
        <div class="col-xs-12 col-md-9">
          <div class="form-title">{{ form.name }}</div>

          <!-- ------------------------------ Rendezvény adatai ------------------------------ -->

          <h5 class="form-block-title-layout-tab">
            <span>Rendezvény adatai</span>
          </h5>
          <div class="row">
            <div class="col-md-12">
              <inputbox :errors="errors" iconclass="fa fa-pencil" id="r_nev" label="Név" name="r_nev" v-model="palyazati_adatok.r_nev"/>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="form-label">
                  Kategória
                </label>
                <select class="form-control" name="r_kat" id="r_kat" v-model="palyazati_adatok.r_kat">
                  <option v-for="(opt, i) in kategoriak" :value="opt.value">{{ opt.text }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <inputbox :errors="errors" iconclass="fa fa-pencil" id="r_helyszin" label="Helyszín" name="r_helyszin" v-model="palyazati_adatok.r_helyszin"/>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <inputbox :errors="errors" :readonly="true" :datepicker="true" iconclass="fa fa-pencil" id="r_datum" label="Dátumtól" name="r_datum" v-model="palyazati_adatok.r_datum"/>
            </div>
            <div class="col-md-6">
              <inputbox :errors="errors" :readonly="true" :datepicker="true" iconclass="fa fa-pencil" id="r_datum_v" label="Dátumig" name="r_datum_v" v-model="palyazati_adatok.r_datum_v"/>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <inputbox :errors="errors" regexp_filter="[0-9]+" mask="99:99" iconclass="fa fa-pencil" id="r_idopont" label="Időpontól" name="r_idopont" v-model="palyazati_adatok.r_idopont"/>
            </div>
            <div class="col-md-6">
              <inputbox :errors="errors" regexp_filter="[0-9]+" mask="99:99" iconclass="fa fa-pencil" id="r_idopont_v" label="Időpontig" name="r_idopont_v" v-model="palyazati_adatok.r_idopont_v"/>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <inputbox :errors="errors" iconclass="fa fa-pencil" id="r_celcsop" label="Célcsoport" name="r_celcsop" v-model="palyazati_adatok.r_celcsop"/>
            </div>
            <div class="col-md-6">
              <inputbox :errors="errors" regexp_filter="[0-9]+" iconclass="fa fa-pencil" id="r_rsz" label="Résztvevők tervezett száma" name="r_rsz" v-model="palyazati_adatok.r_rsz"/>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <inputbox :disabled="true" :errors="errors" iconText="Ft" id="r_osszk" label="Összköltség" name="r_osszk" v-model="palyazati_adatok.r_osszk"/>
            </div>
            <div class="col-md-6">
              <inputbox :errors="errors" regexp_filter="[0-9]+" iconText="Ft" id="r_igt" label="Igényelt támogatás" name="r_igt" v-model="palyazati_adatok.r_igt"/>
            </div>
          </div>

          <!-- ------------------------------ Rendezvény költségvetése ------------------------------ -->

          <h5 class="form-block-title-layout-tab">
            <span>
              Rendezvény költségvetése
            </span>
          </h5>

          <h6>Bevételek</h6>
          <BevetelKiadasElem :global_errors="errors" id="penzbeli_tamogatas" :elemek="palyazati_adatok.bevetelek"/>
          <BevetelKiadasElem :global_errors="errors" id="atvallalt_koltsegek" :elemek="palyazati_adatok.bevetelek"/>
          <BevetelKiadasElem :global_errors="errors" id="termektamogatas" :elemek="palyazati_adatok.bevetelek"/>
          <BevetelKiadasElem :global_errors="errors" id="hallgatoi_hozzajarulas" :elemek="palyazati_adatok.bevetelek"/>
          <BevetelKiadasElem :global_errors="errors" id="egyeb_tamogatas" :elemek="palyazati_adatok.bevetelek"/>

          <h6>Kiadások</h6>
          <BevetelKiadasElem :global_errors="errors" id="anyagkoltseg" :elemek="palyazati_adatok.kiadasok"/>
          <BevetelKiadasElem :global_errors="errors" id="szolgaltatasok" :elemek="palyazati_adatok.kiadasok"/>
          <BevetelKiadasElem :global_errors="errors" id="egyeb_koltsegek" :elemek="palyazati_adatok.kiadasok"/>

          <div class="revenue-expense-summ-row">
            Összes bevétel: <span>{{ bevetelKalkulacio }}</span>
          </div>
          <div class="revenue-expense-summ-row">
            Összes kiadás: <span>{{ kiadasKalkulacio }}</span>
          </div>
          <div class="revenue-expense-summ-row">
            Rendezvény költségvetése: <span>{{ koltsegvetesKalkulacio }}</span>
          </div>

          <!-- ------------------------------ Rendezvény bemutatása ------------------------------ -->

          <h5 class="form-block-title-layout-tab">
            <span>
              Rendezvény bemutatása
            </span>
          </h5>

          <textareabox cstyle="min-height: 100px" placeholder="A rendezvény bemutatása" maxlength="2000" :autogrow="true" iconclass="fa fa-pencil" id="rendezveny_leiras" label="A rendezvény bemutatása" name="rendezveny_leiras" v-model="palyazati_adatok.rendezveny_leiras"/>

          <div style="display: flex; justify-content: space-between; align-items: center">
            <button v-on:click="save" type="button" name="kuld" class="button" :disabled="!save_enabled" >Beküld</button>
          </div>
        </div>

      </div>
    </div>
    <div class="container" v-else>
      <div class="row">
        <div class="col-xs-12">
          <div class="form-title">{{ form.name }}</div>
          <div class="article-text" v-html="fill_info">{{ fill_info }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import HallgatoAdatok from './hatar_hallgato_adatok.vue';
import moment from 'moment';

Vue.component('BevetelKiadasElem', {
  props: {
    elemek: {
      type: Array,
      required: true
    },
    global_errors: {
      type: Array,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      elem: '',
      ujsor: {
        megn: '',
        osszeg: ''
      },
      errors: []
    };
  },
  template: `
    <div>
      <div class="revenue-expense-title">
        {{ cim }}
        <span>{{ osszeg }}</span>
      </div>
      <div v-if="elem != ''" v-for="(sor, i) in elem.sorok" class="revenue-expense-row">
        <inputbox :errors="errors" iconclass="fa fa-pencil" :id="elem.id+'_sor_megn_'+i" label="" :name="elem.id+'_sor_megn_'+i" v-model="sor.megn"/>
        <inputbox :errors="errors" iconText="Ft" regexp_filter="[0-9]+" :id="elem.id+'_sor_osszeg_'+i" label="" :name="elem.id+'_sor_osszeg_'+i" v-model="sor.osszeg"/>
        <button v-on:click="sorTorles(i)" type="button" class="button only-icon"><i class="fa fa-trash-o"></i></button>
      </div>
      <div class="revenue-expense-row">
        <inputbox :errors="errors" iconclass="fa fa-pencil" label="" :id="elem.id+'_uj_sor_megn'" :name="elem.id+'_uj_sor_megn_'" v-model="ujsor.megn"/>
        <inputbox :errors="errors" iconText="Ft" regexp_filter="[0-9]+" label="" :id="elem.id+'_uj_sor_osszeg'" :name="elem.id+'_uj_sor_osszeg'" v-model="ujsor.osszeg"/>
        <button v-on:click="ujSor" type="button" class="button v3 only-icon small"><i class="fa fa-plus"></i></button>
      </div>
    </div>
  `,
  watch: {
    global_errors: function() {
      this.errors = this.global_errors;
    }
  },
  computed: {
    cim: function() {
      if (this.elem != '')
        return this.elem.nev;
      else
        return '';
    },

    osszeg: function() {
      var total = 0;

      if (this.elem != '') {
        this.elem.sorok.map(function(sor) {
          if (sor.osszeg != '')
            total += parseInt(sor.osszeg);
        });

        total = new Intl.NumberFormat('hu-HU', { minimumFractionDigits: 0 }).format(total) + ' Ft';
      }

      return total;
    }
  },

  mounted: function() {
    var _this = this;

    this.elemek.map(function(elem) {
      if (elem.id == _this.id)
        _this.elem = elem;
    });
  },

  methods: {
    ujSor: function() {
      this.errors = [];

      if (this.ujsor.megn == '')
        this.errors.push({
          id: this.elem.id + '_uj_sor_megn',
          msg: 'kötelező'
        });

      if (this.ujsor.osszeg == '')
        this.errors.push({
          id: this.elem.id + '_uj_sor_osszeg',
          msg: 'kötelező'
        });

      if (this.errors.length == 0) {
        this.elem.sorok.push({
          megn: this.ujsor.megn,
          osszeg: this.ujsor.osszeg
        });

        this.ujsor = {
          megn: '',
          osszeg: ''
        }
      }
    },

    sorTorles: function(index) {
      this.elem.sorok.splice(index, 1);
    }
  }
});

export default {
  components: {
    HallgatoAdatok
  },

  data: function() {
    return {
      fill_info: '',
      save_enabled: false,
      errors: [],
      palyazati_adatok: {
        r_nev: '',
        r_kat: 1,
        r_helyszin: '',
        r_idopont: '',
        r_idopont_v: '',
        r_datum: '',
        r_datum_v: '',
        r_celcsop: '',
        r_rsz: '',
        r_osszk: '',
        r_igt: '',
        rendezveny_leiras: '',
        bevetelek: [{id:'penzbeli_tamogatas',nev:'Pénzbeli támogatás',sorok:[]},{id:'atvallalt_koltsegek',nev:'Átvállalt költségek',sorok:[]},{id:'termektamogatas',nev:'Terméktámogatás',sorok:[]},{id:'hallgatoi_hozzajarulas',nev:'Hallgatói hozzájárulás',sorok:[]},{id:'egyeb_tamogatas',nev:'Egyéb támogatás',sorok:[]}],
        kiadasok: [{id:'anyagkoltseg',nev:'Anyagköltség',sorok:[]},{id:'szolgaltatasok',nev:'Szolgáltatások',sorok:[]},{id:'egyeb_koltsegek',nev:'Egyéb költségek',sorok:[]}]
      },
      form: {
        name: 'Hallgatói Önkormányzat és Hallgatói Szervezetek kulturális rendezvényeinek támogatása',
        id: 0
      },
      elemleirasok: [],
      kategoriak: [{"value":"1","text":"HÖK csapatépítő"},{"value":"2","text":"Kötetlen szakrendezvény"},{"value":"3","text":"Szakmai program"},{"value":"4","text":"Báli rendezvény"},{"value":"5","text":"Többnapos rendezvény"},{"value":"6","text":"Egyéb"},{"value":"7","text":"Szervezeti támogatás"}],
    }
  },

  computed: {
    bevetelKalkulacio: function() {
      var total = 0;

      this.palyazati_adatok.bevetelek.map(function(bevetel) {
        bevetel.sorok.map(function(sor) {
          if (sor.osszeg != '')
            total += parseInt(sor.osszeg);
        });
      });

      total = new Intl.NumberFormat('hu-HU', { minimumFractionDigits: 0 }).format(total) + ' Ft';

      return total;
    },

    kiadasKalkulacio: function() {
      var total = 0;

      this.palyazati_adatok.kiadasok.map(function(kiadas) {
        kiadas.sorok.map(function(sor) {
          if (sor.osszeg != '')
            total += parseInt(sor.osszeg);
        });
      });

      total = new Intl.NumberFormat('hu-HU', { minimumFractionDigits: 0 }).format(total) + ' Ft';

      return total;
    },

    koltsegvetesKalkulacio: function() {
      var kiadas_total = 0;
      var bevetel_total = 0;
      var total = 0;

      this.palyazati_adatok.kiadasok.map(function(kiadas) {
        kiadas.sorok.map(function(sor) {
          if (sor.osszeg != '')
            kiadas_total += parseInt(sor.osszeg);
        });
      });

      this.palyazati_adatok.bevetelek.map(function(bevetel) {
        bevetel.sorok.map(function(sor) {
          if (sor.osszeg != '')
            bevetel_total += parseInt(sor.osszeg);
        });
      });

      this.palyazati_adatok.r_osszk = bevetel_total-kiadas_total;

      total = new Intl.NumberFormat('hu-HU', { minimumFractionDigits: 0 }).format(bevetel_total-kiadas_total) + ' Ft';

      return total;
    }
  },

  mounted: function() {
  	var _this = this;

    this.$root.ajax('form/urlap_kitoltheto/RendezvenySzervezesTamogatasiPalyazat/' + this.$root.user.id, {
      method: 'GET',
      success: function(response) {
        if (response.error == false) {
          if (!response.kitoltheto) {
            _this.fill_info = 'Az űrlap nem tölthető ki.';

          } else {
            _this.$root.ajax('form/getFormByVueComponent/RendezvenySzervezesPalyazat', {
              method: 'GET',
              success: function(response) {
                if (response.error == false) {
                  if(response.form != false) {
                    _this.form.name = response.form.name;
                    _this.form.id = response.form.id;
                    _this.save_enabled = true;
                  } else {
                    _this.fill_info = 'Ez a pályázat jelenleg nem beadható!';
                  }
                } else  {
                  swal('Hiba!', response.error, 'error');
                }
              }
            });
          }
        } else {
          swal('Hiba!', response.error, 'error');
        }
      }
    });
  },

  methods: {
    save: function() {
      var _this = this;

      this.errors = [];

      this.palyazati_adatok.r_idopont = this.palyazati_adatok.r_idopont.replace("_", "");
      this.palyazati_adatok.r_idopont_v = this.palyazati_adatok.r_idopont_v.replace("_", "");

      this.$root.ajax('form/ment/rendezveny_szervezes_tamogatasi_palyazat/', {
        method: 'POST',
        data: {
          form: this.palyazati_adatok,
          form_id: this.form.id,
          user_id: this.$root.user.id
        },
        success: function(response) {
          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            })

          } else if (response.error) {
            swal('Hiba!', response.error, 'error');

          } else {
            _this.fill_info = response.fill_info;
          }
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// rendezveny_szervezes_tamogatasi_palyazat.vue?4860edff